import {escapeHtml} from './html';


const SEARCH_INPUT_SELECTOR = '.app-search-control__input';
const SEARCH_CLEAR_SELECTOR = '[data-search-clear]';
let initialized = false;


export function renderSearchControl({
    id,
    label,
    placeholder = '',
    clearLabel = 'Clear search',
    className = '',
    inputClassName = '',
    value = '',
}) {
    const hasValue = String(value || '').length > 0;
    return `
        <div class="app-search-control ${escapeHtml(className)}">
            <label class="visually-hidden" for="${escapeHtml(id)}">${escapeHtml(label)}</label>
            <input type="search" class="form-control og-input app-search-control__input ${escapeHtml(inputClassName)}"
                   id="${escapeHtml(id)}" value="${escapeHtml(value)}"
                   placeholder="${escapeHtml(placeholder)}" autocomplete="off">
            <button type="button" class="input-clear-button" data-search-clear
                    aria-label="${escapeHtml(clearLabel)}" ${hasValue ? '' : 'hidden'}>
                <span class="input-clear-icon" aria-hidden="true"></span>
            </button>
        </div>`;
}


export function syncSearchControl(input) {
    const element = input?.jquery ? input[0] : input;
    if (!element?.matches?.(SEARCH_INPUT_SELECTOR)) return;
    const button = element.closest('.app-search-control')?.querySelector(SEARCH_CLEAR_SELECTOR);
    if (button) button.hidden = !String(element.value || '').length;
}


export function initSearchControls() {
    if (initialized) return;
    initialized = true;
    document.querySelectorAll(SEARCH_INPUT_SELECTOR).forEach(syncSearchControl);
    document.addEventListener('input', (event) => {
        syncSearchControl(event.target);
    });
    document.addEventListener('click', (event) => {
        const button = event.target.closest?.(SEARCH_CLEAR_SELECTOR);
        if (!button) return;
        const input = button.closest('.app-search-control')?.querySelector(SEARCH_INPUT_SELECTOR);
        if (!input) return;
        input.value = '';
        input.dispatchEvent(new Event('input', {bubbles: true}));
        input.focus();
    });
}
